module.exports = __webpack_public_path__ + "static/media/empf goal.618855fb.png";